// import { useSelector } from "react-redux"

import Button from "components/ui/button"
import { IS_NA, IS_CA, IS_US, isTestMode } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()

  return () => {
    try {
      if (IS_NA()) {
        const attentiveBoxID = isMobile
          ? IS_US()
            ? 1306983 // US Mobile
            : 1311719 // CA Mobile
          : IS_US()
            ? 1306982 // US Desktop
            : 1311567 // CA Desktop
        window.__attentive.trigger(null, null, null, attentiveBoxID)
        // } else if (IS_INT()) {
        //   const globaleBoxID = "aee6786c-941d-4447-a7e9-74364ff13e18" // global e 321134
        //   window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        const lightboxID = "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

const FooterSubscribe = () => {
  const showSpinToWin = !IS_CA()

  const triggerPopup = usePopupTrigger()

  return (
    <div className="bg-primary text-white">
      <div className="tablet:items-center tablet:gap-48 contained-wide tablet:flex-row widescreen:px-60 widescreen:py-60 tablet:px-32 flex flex-col items-start justify-between px-16 py-32">
        <h2 className="display-md leading-72 desktop:leading-none tablet:mb-0 mb-24 shrink-0 whitespace-nowrap font-bold">
          Stay
          <wbr /> in touch
        </h2>
        <div className="tablet:w-auto tablet:items-end xlarge:items-center xlarge:flex-row flex w-full flex-col items-start">
          <p className="xlarge:mr-64 tablet:text-right body-lg desktop:font-semibold desktop:leading-none tablet:mb-8 xlarge:mb-0 mb-24 whitespace-nowrap font-normal">
            {showSpinToWin ? (
              <>
                Subscribe to our emails
                <wbr /> and spin to win
              </>
            ) : (
              <>
                Subscribe to our emails
                <wbr /> and save an extra 15%
              </>
            )}
          </p>
          <Button
            className="tablet:w-(--tablet-width) outline-black-print widescreen:w-(--widescreen-width) w-full uppercase"
            onClick={() => {
              if (!isTestMode) {
                dataLayer.push({ event: "trigger-footer-sign-up-unit" })
              }

              triggerPopup()
            }}
            style={{
              "--tablet-width": "230px",
              "--widescreen-width": "300px",
            }}
            variant="primary"
          >
            {/* {showSpinToWin ? "Get your code" : "Sign up now"} */}
            Get your code
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FooterSubscribe
